// MF entry exposed as ./AppMount: load runtime settings, register remotes, then mount the bootloader.
import { loadAppSettings } from './appSettings';
import { registerRuntimeRemotes } from './designSystemRemote';

// Settings the app can't boot without; validated up front to fail fast with a clear message.
const REQUIRED_SETTINGS = [
  'SHIPBOB_DESIGN_SYSTEM',
  'SHIPBOB_MFE_RUNTIME',
  'AUTHENTICATION_AUTHORITY',
  'CLIENT_ID',
  'CLIENT_SCOPE',
  'MFE_ROOT_ROUTE',
];

/** Load settings, validate required keys (throws listing any missing), then register the runtime remotes. */
export async function prepareRuntime(action) {
  const appSettings = await loadAppSettings();

  const missing = REQUIRED_SETTINGS.filter(
    (key) => typeof appSettings[key] !== 'string' || !appSettings[key].trim(),
  );
  if (missing.length) {
    throw new Error(
      `[transportation-network-ui] cannot ${action}: missing required app settings: ${missing.join(', ')}`,
    );
  }

  registerRuntimeRemotes(appSettings);
}

/** Mount into a host-provided element; returns the bootloader's unmount fn. */
export const mount = async (args = {}) => {
  await prepareRuntime('mount');
  const { mount: appMount } = await import('./bootloader');
  return appMount(args);
};
